
import React, {useCallback } from "react";
import {useParams} from "react-router";
import {useDiaEditor} from "../../components/DiaEditor";
import {NonIdealState} from "../../components/NonIdealState";
import WaitSpinner from "../../components/wait-spinner";
import CompanyForm from "./Form";
import * as yup from "yup";
import {
    ClientCompany,
    CreateClientCompanyMutation,
    GetClientCompanyQueryResult,
    UpdateClientCompanyInput,
    UpdateClientCompanyMutation,
    UpdateClientCompanyMutationResult,
    useCreateClientCompanyMutation, useGetClientCompanyQuery,
    useUpdateClientCompanyMutation
} from "../../generated/graphql";

const schema = yup.object().shape({
    accounts_company: yup.string().min(1),
    clientType: yup.object().required()
});



const contactRelationships = {
    'clientCompanyGroup':'connect',
    'clientType':'connect'
};

function blankCompany(): ClientCompany {
    return {
        id: 'new',
        accounts_company: '',
        accounts_address: '',
        accounts_contact: '',
        accounts_phone: '',
        accounts_email: '',
        accounts_postcode: '',
        accounts_account_code: '',
        accounts_comments: '',
        clientType:null,
        clientCompanyGroup: null,
        is_po_required: false,
        is_vat_exempt: false,
        credit_limit: 0,
        current_credit: 0,
        sales_company: '',
        sales_address: '',
        sales_contact: '',
        sales_mobile: '',
        sales_postcode: '',
        sales_title: '',
        sales_phone: '',
        sales_type: '',
        other_contacts: '',
        invoice_factored: false
    };
}


function cleanGraphqlVariables(variables:UpdateClientCompanyInput & { contacts?: any; campaigns?: any },dummy) {
    if (!variables) {
        alert('NO VARIABLES');
        return;
    }
    if(variables?.contacts) {
        delete (variables?.contacts);
    }
    if(variables?.campaigns) {
        delete (variables?.campaigns);
    }
    return variables;
}

export function CompanyEditor() {
    const params = useParams();
    const isNew = (params.id=='new');
    const query = useGetClientCompanyQuery({variables:{id:params.id},skip:isNew});
    const [saveMutation,saveResult] = useUpdateClientCompanyMutation();
    const [createMutation,createResult] = useCreateClientCompanyMutation();
    const save = useCallback(({values})=>{
        return saveMutation({variables:{input:values}});
    },[]);
    const create = useCallback(({values})=>{
        return createMutation({variables:{input:values}});
    },[]);
    const getValue = useCallback((result:GetClientCompanyQueryResult)=>{
        return result?.data?.clientCompany as ClientCompany;
    },[]);
    const getSaveValue = useCallback((result:UpdateClientCompanyMutationResult)=>{
        return result?.data?.updateClientCompany as ClientCompany;
    },[]);
    const getCreateRedirect = useCallback(({data,baseUrl})=>{
        console.log('data is',data);
        return baseUrl+(data?.data?.createClientCompany?.id);
    },[]);

    const data = useDiaEditor<ClientCompany,GetClientCompanyQueryResult,CreateClientCompanyMutation,UpdateClientCompanyMutation>({
        save,
        saveResult,
        create,
        createResult,
        query:query,
        relationships:contactRelationships,
        baseUrl:'/companies/',
        blankValues:blankCompany,
        label:'Companies',
        permission:'contacts',
        validationSchema:schema,
        getValue:getValue,
        cleanGraphqlVariables,
        getSaveValue:getSaveValue,
        getCreateRedirect:getCreateRedirect
    });

    if (query.error) {
        return <NonIdealState
            severity="error"
            title="An error has occurred"
            message="GraphQL error encountered"
        />;
    }
    if(data.form.status=='loading') {
        return <WaitSpinner variant="panel"/>;
    }
    return <>{data.confirmation}<CompanyForm waiting={data.waiting} diaForm={data.form} /></>;
}